
// 👇已经启用的货币列表（经常用它滤除不需要的信息）
export const aCurrencyInUse = [
    // ↓ 玩家可以使用这些币种下注 
    'btc', 'eth', 'usdt', 'cny', 'usd', sCorgiCoin,
    // ↓ 再补充一些 waves 用到的币种 
    'ada', 'avax', 'bch', 'bnb', 'doge', 'not', 'sol', 'xrp',
];


export const oAmountTips = {
    // '键名': 'i18n key',
    'noMoneyPleaseCharge':  'amountTips.noMoneyPleaseCharge', // '余额不足，请充值', 
    'reachedLowerLimit':  'amountTips.reachedLowerLimit', // '已到达投注金最小值', 
    'reachedUpperLimit':  'amountTips.reachedUpperLimit', // '已到达投注金额最大值', 
    'reachedUserBalance':  'amountTips.reachedUserBalance', // '已到达用户余额',
}


